export default "__VITE_ASSET__BdSjHGah__"